module.exports = __webpack_public_path__ + "mp.7e3550d7.svg";